import { message } from "antd";
import axios from "axios";

const service = axios.create({
  timeout: 30000,
});

const err = (error) => {
  if (error.response) {
    onceResponseWarning(error.response?.data);
  }
  return Promise.reject(error);
};

service.interceptors.request.use((config) => {
  config.data = Object.assign({}, config.data);
  if (config.method === "post") {
    let data = "";
    for (let item in config.data) {
      if (config.data[item]) {
        data +=
          encodeURIComponent(item) +
          "=" +
          encodeURIComponent(config.data[item]) +
          "&";
      }
    }
    config.data = data.slice(0, data.length - 1);
  }
  return config;
}, err);

message.config({
  top: 50,
  maxCount: 1,
  duration: 1.8,
});

let onceResponseWarningKey = "onceResponseWarningKey";

export function onceResponseWarning(res) {
  if (res && res.resultCode !== 0) {
    message.destroy(onceResponseWarningKey);
    message.warning({
      content: res.errorMsg || "响应错误，请重试或联系管理员",
      key: onceResponseWarningKey,
    });
  }
}

service.interceptors.response.use((response) => {
  const {
    status,
    data,
    data: { result, resultCode },
  } = response || {};
  onceResponseWarning(data);
  if (resultCode || status >= 300) {
    return Promise.reject(new Error(data?.errorMsg || '响应错误'));
  }
  return Promise.resolve(result);
}, err);

export { service as axios };
